
import { useNavigate } from 'react-router-dom'
import './Togglebar.css'

const Togglebar = () => {
const navigate=useNavigate();
const handleProfile=()=>{
  navigate("/profile")
}
const handleZapprofessional=()=>{
  navigate("/Professional")
}

  return (
    <>
    <div className="switch-wrapper w-11/12 mx-auto  ">
      <label htmlFor="filter" className="switch" aria-label="Toggle Filter">
        <input type="checkbox" id="filter" />
        <span onClick={handleProfile} >Profile</span>
        <span onClick={handleZapprofessional}>My Profession</span>
      </label>
    </div>
    <div className="page-content">
   
      </div>
      </>
  )
}

export default Togglebar